module.exports = __webpack_public_path__ + "img/28.64f45cc8.jpg";